module.exports = __webpack_public_path__ + "img/icons B_20.f1d065bc.svg";